// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img {
   background-image: url('setFlow.jpg');
   background-repeat: no-repeat;
}

.item {
   height: 494px;
}

.center {
   margin: auto;
   width: 62%;
   border: 3px solid #8c8c8c;
   padding: 10px;
}

.box-group {
   border: 3px solid #a7a6a6;
   border-radius: 25px;
   margin-bottom: 5px;
}

.box-item {
   width: 140px;
   height: 60px;
   border: 3px solid #a7a6a6;
   border-radius: 25px;
   background-color: rgba(204, 223, 231, 0.67);
   margin: 10px;
   display: inline-block;
   text-align: center;
}

/* Tooltip container */
.tooltip {
   position: relative;
   display: inline-block;
}

/* Tooltip text */
.tooltip .tooltiptext {
   visibility: hidden;
   box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15);
   max-width: 300px;
   /* width: 120px; */
   background-color: rgba(224, 228, 222, 1);
   color: #000;
   text-align: center;
   padding: 10px;
   border-radius: 6px;

   /* Position the tooltip text */
   position: absolute;
   z-index: 300;
   bottom: 100%;
   left: 50%;
   margin-left: -60px;

   /* Fade in tooltip */
   opacity: 0;
   transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
   content: "";
   position: absolute;
   top: 95%;
   left: 50%;
   margin-left: -5px;
   border-width: 12px;
   border-style: solid;
   border-color: rgba(224, 228, 222, 1) transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
   visibility: visible;
   opacity: 1;
   z-index: 1010;
}

.btndel {
   width: 25px;
   height: 25px;
   background-color: transparent;
   border-width: 0px;
   border-color: transparent;
   float: right;
   margin-right: 15px;
   cursor: pointer
}

.rightClickPanel {
   width: 200px;
   padding-bottom: 10px;
   position: absolute;
   border: 1px solid #ccc;
   background: #fff;
   display: none;
   z-index: 1;
}

.toolbar {
   align-items: center;
}

.menu {
   list-style: none;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.btnContext {
   width: 100%;
   text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/mail-flow/flow-recipients/flow-recipients.component.css"],"names":[],"mappings":"AAAA;GACG,oCAA8D;GAC9D,4BAA4B;AAC/B;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,YAAY;GACZ,UAAU;GACV,yBAAyB;GACzB,aAAa;AAChB;;AAEA;GACG,yBAAyB;GACzB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,YAAY;GACZ,yBAAyB;GACzB,mBAAmB;GACnB,2CAA2C;GAC3C,YAAY;GACZ,qBAAqB;GACrB,kBAAkB;AACrB;;AAEA,sBAAsB;AACtB;GACG,kBAAkB;GAClB,qBAAqB;AACxB;;AAEA,iBAAiB;AACjB;GACG,kBAAkB;GAClB,0CAA0C;GAC1C,gBAAgB;GAChB,kBAAkB;GAClB,wCAAwC;GACxC,WAAW;GACX,kBAAkB;GAClB,aAAa;GACb,kBAAkB;;GAElB,8BAA8B;GAC9B,kBAAkB;GAClB,YAAY;GACZ,YAAY;GACZ,SAAS;GACT,kBAAkB;;GAElB,oBAAoB;GACpB,UAAU;GACV,wBAAwB;AAC3B;;AAEA,kBAAkB;AAClB;GACG,WAAW;GACX,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,iBAAiB;GACjB,kBAAkB;GAClB,mBAAmB;GACnB,wEAAwE;AAC3E;;AAEA,oEAAoE;AACpE;GACG,mBAAmB;GACnB,UAAU;GACV,aAAa;AAChB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,6BAA6B;GAC7B,iBAAiB;GACjB,yBAAyB;GACzB,YAAY;GACZ,kBAAkB;GAClB;AACH;;AAEA;GACG,YAAY;GACZ,oBAAoB;GACpB,kBAAkB;GAClB,sBAAsB;GACtB,gBAAgB;GAChB,aAAa;GACb,UAAU;AACb;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,WAAW;GACX,gBAAgB;AACnB","sourcesContent":[".img {\n   background-image: url(\"../../../../assets/images/setFlow.jpg\");\n   background-repeat: no-repeat;\n}\n\n.item {\n   height: 494px;\n}\n\n.center {\n   margin: auto;\n   width: 62%;\n   border: 3px solid #8c8c8c;\n   padding: 10px;\n}\n\n.box-group {\n   border: 3px solid #a7a6a6;\n   border-radius: 25px;\n   margin-bottom: 5px;\n}\n\n.box-item {\n   width: 140px;\n   height: 60px;\n   border: 3px solid #a7a6a6;\n   border-radius: 25px;\n   background-color: rgba(204, 223, 231, 0.67);\n   margin: 10px;\n   display: inline-block;\n   text-align: center;\n}\n\n/* Tooltip container */\n.tooltip {\n   position: relative;\n   display: inline-block;\n}\n\n/* Tooltip text */\n.tooltip .tooltiptext {\n   visibility: hidden;\n   box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15);\n   max-width: 300px;\n   /* width: 120px; */\n   background-color: rgba(224, 228, 222, 1);\n   color: #000;\n   text-align: center;\n   padding: 10px;\n   border-radius: 6px;\n\n   /* Position the tooltip text */\n   position: absolute;\n   z-index: 300;\n   bottom: 100%;\n   left: 50%;\n   margin-left: -60px;\n\n   /* Fade in tooltip */\n   opacity: 0;\n   transition: opacity 0.3s;\n}\n\n/* Tooltip arrow */\n.tooltip .tooltiptext::after {\n   content: \"\";\n   position: absolute;\n   top: 95%;\n   left: 50%;\n   margin-left: -5px;\n   border-width: 12px;\n   border-style: solid;\n   border-color: rgba(224, 228, 222, 1) transparent transparent transparent;\n}\n\n/* Show the tooltip text when you mouse over the tooltip container */\n.tooltip:hover .tooltiptext {\n   visibility: visible;\n   opacity: 1;\n   z-index: 1010;\n}\n\n.btndel {\n   width: 25px;\n   height: 25px;\n   background-color: transparent;\n   border-width: 0px;\n   border-color: transparent;\n   float: right;\n   margin-right: 15px;\n   cursor: pointer\n}\n\n.rightClickPanel {\n   width: 200px;\n   padding-bottom: 10px;\n   position: absolute;\n   border: 1px solid #ccc;\n   background: #fff;\n   display: none;\n   z-index: 1;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu {\n   list-style: none;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.btnContext {\n   width: 100%;\n   text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
